<main class="main" id="top">
    <div class="container-fluid">
        <div class="row min-vh-100 flex-center g-0">
            <div class="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-7 py-3 position-relative">
                <div class="card overflow-hidden z-index-1">
                    <div class="card-body p-0">
                        <div class="row g-0 h-100">
                            <div class="col-sm-12 col-md-6 col-lg-6 bg-card-gradient">
                                <div class="position-relative p-3">
                                    <div class="z-index-1 position-relative p-3">

                                        <p class="mt-3 d-flex">
                                            <img src="assets/img/icons/spot-illustrations/new-logo-iceipt.png"
                                                alt="iceipts logo" width="80" height="80">
                                        </p>
                                        <i class="fas fa-quote-left d-flex mt-5" style="color: #00DAF7;"></i>
                                        <br><br>
                                        <p class="opacity-75 text-white d-flex justify-content-center leftText">
                                            The technology that looks impossible today will<br>be part of our life
                                            tomorrow. Iceipts technology<br>creating difference.
                                        </p>

                                        <p class="opacity-75 text-white d-flex">Sibanee kar</p>
                                    </div>
                                </div>

                                <!-- <div class="position-relative pt-md-7 pb-md-7 light">
                                    <div class="bg-holder bg-auth-card-shape" style="
                                        background-image: url(../../../assets/img/icons/spot-illustrations/half-circle.png);
                                        ">
                                    </div> -->
                                    <!--/.bg-holder-->
                                    <!-- <div class="z-index-1 position-relative">
                                        <a
                                            class="link-light mb-4 mt-3 font-sans-serif fs-4 d-inline-block fw-bolder">iCeipts</a>
                                        <p class="opacity-75 text-white">
                                            Welcome!
                                        </p>
                                        <p class="mt-3">
                                            <img src="../assets/img/logos/96_icon3.png" alt="iceipts logo" width="90"
                                                height="90">
                                        </p>
                                        <p class="opacity-75 text-white">
                                            Take your shopping experience a level ahead
                                        </p>
                                    </div>
                                </div>
                                <div class="mt-3 mb-4 light">
                                    <p class="text-white">
                                        Don't have an account?<br /><a class="text-decoration-underline link-light"
                                            routerLink="/auth/register">Get started!</a>
                                    </p>
                                    <p class="mb-0 mt-4 mt-md-5 fs--1 fw-semi-bold text-white opacity-75">
                                        Read our
                                        <a class="text-decoration-underline text-white">terms</a> and
                                        <a class="text-decoration-underline text-white">conditions
                                        </a>
                                    </p>
                                </div> -->
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6 form-box">
                                <div class="p-4 p-md-5 flex-grow-1 form-body">
                                    <div class="text-center text-md-start">
                                        <h4 class="mb-0" style = "font-family: 'Poppins';">Verify your OTP</h4>
                                        <p class="mb-4 "  style = "font-family: 'Poppins';">Enter your Email and we'll send you a reset link.</p>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-sm-8 col-md">
                                            <form [formGroup]="VerifyOTPForm" class="mb-3">
                                                <input class="form-control mb-2" formControlName="forgetpass"
                                                    type="email" placeholder="Email address"
                                                    [ngClass]="{
                                                    'is-invalid': (f.forgetpass.invalid && f.forgetpass.touched) && submitted }" />
                                                <mat-error class="text-danger mb-1"
                                                    *ngIf="(submitted || f.forgetpass.touched)">
                                                    <mat-error *ngIf="f.forgetpass.errors?.required">
                                                        Email Address Is Required.
                                                    </mat-error>
                                                    <mat-error *ngIf="f.forgetpass.errors?.pattern">
                                                        Email Is Required in Format.
                                                    </mat-error>
                                                </mat-error>

                                                <input class="form-control mb-2" (keypress)="numberOnly($event)"
                                                    formControlName="otp" type="email" placeholder="Enter OTP"
                                                    [ngClass]="{
                                                        'is-invalid': (f.otp.invalid && f.otp.touched) && submitted }" />
                                                <mat-error class="text-danger mb-1"
                                                    *ngIf="(submitted || f.otp.touched)">
                                                    <mat-error *ngIf="f.otp.errors?.required">
                                                        OTP Is Required.
                                                    </mat-error>
                                                </mat-error>
                                                <!-- <div style="margin-bottom: -13px;" *ngIf="submitted && f.forgetpass.errors" class="invalid-feedback">
                                                        Forget password is required
                                                    </div> -->
                                                <button class="btn btn-primary d-block w-100 mt-3" type="submit" style="background: #110152;"
                                                    name="submit" (click)="postforgotpassword()"><span  style = "font-family: 'Poppins';">Verify OTP</span></button>
                                            </form><a class="fs--1 text-600" routerLink="/auth/login"><span  style = "font-family: 'Poppins';">Back to Login</span>
                                                <span  style = "font-family: 'Poppins';">this page</span><span class="d-inline-block ms-1">&rarr;</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
